var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadingArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.655,
    height: 72.082,
    viewBox: "0 0 173.655 72.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66102",
    "data-name": "Group 66102",
    transform: "translate(-378.219 -379.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93453",
    "data-name": "Path 93453",
    d: "M3097.858,16890.932s77.909-27.742,92.876,19.51-38.934,51.092-46.24,34.482,20.967-41.945,58.534-32.834,18.25,37.785,4.378,25.91,15.514-30.861,51.987-19.535",
    transform: "translate(-2719 -16503)",
    fill: "none",
    stroke: "#313131",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93454",
    "data-name": "Path 93454",
    d: "M6.3,2.535a1.142,1.142,0,0,1,1.937,0l5.634,8a1.142,1.142,0,0,1-.968,1.747H2.749a1.142,1.142,0,0,1-.968-1.747Z",
    transform: "translate(554.183 410.8) rotate(103)",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingArrow);
export default __webpack_public_path__ + "static/media/heading_arrow.b986c839e3d1b0f395b6156af2b515d1.svg";
export { ForwardRef as ReactComponent };